module.exports = __webpack_public_path__ + "static/media/DqEveryChildClassroomsHero.9dd01f1f.jpg";